module.exports = __webpack_public_path__ + "img/result-btn_txt.6a654fe7.png";